import {css} from 'lit';
export const styles = css`[cloak] {
  display: none !important;
}

/* Make sure to use CSS variables as much as possible to keep this component flexible! */
:host {
  --loader-min-height: 250px; /* Minimal height of the placeholder as long as the dynamically loader CSS/JS is not fully loaded */
  --frame-borderwidth--border-width-m: 2px;
  --color-neutrals--neutral-100: #f3f5f6;

  font-weight: 400;
  font-size: 14px;
  line-height: 1.4;
  font-family:
    On Air,
    Verdana,
    Tahoma,
    sans-serif;
}

.purpose-description {
  height: 120px;
  overflow: auto;
}
`;
export default styles;
